'use client';

import { useState } from 'react';

import { ApproveDeclineTradeForm } from '@/components/forms';
import { ModalWrapper } from '@/components/organisms/ModalWrapper';
import { ApproveDeclineTradeData } from '@/entities';

interface ApproveDeclineTradeModallProps {
	tradeTo: { firstName: string; lastName: string };
	tradeFor: { firstName: string; lastName: string };
	teamName: string;
}

export const ApproveDeclineTradeModal = ({ tradeTo, tradeFor, teamName }: ApproveDeclineTradeModallProps) => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const toggleModal = () => {
		setShowModal((prev) => !prev);
	};

	const handleFormSubmit = (_data: ApproveDeclineTradeData) => {
		toggleModal();
	};

	return (
		<>
			<button onClick={toggleModal}>show modal for trade decline</button>

			{showModal ? (
				<ModalWrapper className="!max-w-[475px] !gap-4" title="Approve or Decline trade" onClose={toggleModal} closeOnOutsideClick>
					<ApproveDeclineTradeForm
						tradeFor={tradeFor}
						tradeTo={tradeTo}
						teamName={teamName}
						onSubmit={handleFormSubmit}
						onClose={toggleModal}
					/>
				</ModalWrapper>
			) : null}
		</>
	);
};
